import { flattenMessages } from '../helper/flattenMessages.ts';

import { en } from './en-GB/message.ts';
import { LOCALES } from './locales';
import { ru } from './ru-RU/message.ts';

export const messages = {
  [LOCALES.en]: flattenMessages(en),
  [LOCALES.ru]: flattenMessages(ru)
};
